import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PharmacyReturnModel from "./pharmacymodels/PharmacyReturnModel";
import { FaDownload, FaEdit, FaTrash } from "react-icons/fa";
import { ArrowLeft, Save } from "lucide-react";
import ProductSelectModal from "./pharmacymodels/ProductSelectModal";
import DistributorSelectModal from "./pharmacymodels/DistributorSelectModal";
import toast, { Toaster } from "react-hot-toast";
import ReturnBatchModal from "./pharmacymodels/ReturnBatchModal";

function PharmacyPurchasereturn() {
  const location = useLocation();
  const [showUserTypeModal, setShowUserTypeModal] = useState(false);
  const [selectedReturnType, setSelectedReturnType] = useState(null);
  const [showProductModal, setShowProductModal] = useState(false);
  const [showCreateProductModal, setShowCreateProductModal] = useState(false);
  const [showDistributorModal, setShowDistributorModal] = useState(false);
  const [showBatchModal, setShowBatchModal] = useState(false);
  const [editingDistributorProductId, setEditingDistributorProductId] = useState(null);
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({
    product: "",
    batchNo: "",
    pack: "1 x",
    expiry: "",
    mrp: "",
    stock: "",
    return: "",
    distributor: "",
    invoiceNo: "",
    invoiceDate: "",
    rate: "",
    hsn: "",
  });

  useEffect(() => {
    if (location.state?.openModal) {
      setShowUserTypeModal(true);
    }
  }, [location.state]);

  const handleUserTypeSelect = (selectedType) => {
    setSelectedReturnType(selectedType);
    setShowUserTypeModal(false);
  };

  const handleGoBack = () => {
    window.history.back();
  };

    const handleBatchFieldClick = () => {
      if (!newProduct.product) {
        toast.error("Please select a product first!", {
          position: "top-center",
          style: { background: "#ef4444", color: "#fff", fontWeight: 500 },
        });
        return;
      }
      setShowBatchModal(true);
    };

  const handleSave = () => {
    console.log("Save return", products);
  };

  const handleAddProduct = () => {
    if (newProduct.product.trim()) {
      const productToAdd = {
        ...newProduct,
        id: Date.now(),
        isEditing: false,
      };
      setProducts([...products, productToAdd]);
      setNewProduct({
        product: "",
        batchNo: "",
        pack: "1 x",
        expiry: "",
        mrp: "",
        stock: "",
        return: "",
        distributor: "",
        invoiceNo: "",
        invoiceDate: "",
        rate: "",
        hsn: "",
      });
    }
  };

  const handleEditProduct = (id) => {
    setProducts(
      products.map((product) =>
        product.id === id ? { ...product, isEditing: !product.isEditing } : product
      )
    );
  };

  const handleDeleteProduct = (id) => {
    setProducts(products.filter((product) => product.id !== id));
  };

  const handleProductChange = (id, field, value) => {
    setProducts(
      products.map((product) =>
        product.id === id ? { ...product, [field]: value } : product
      )
    );
  };

  const handleNewProductChange = (field, value) => {
    setNewProduct((prev) => ({ ...prev, [field]: value }));
  };

  const styles = {
    container: {
      padding: "20px",
      background: "#fff",
      minHeight: "100vh",
    },
    header: {
      marginBottom: "20px",
      display: "flex",
      justifyContent: "space-between",
    },
    title: {
      fontSize: "24px",
      fontWeight: "600",
      color: "#333",
      marginBottom: "5px",
    },
    subtitle: {
      fontSize: "14px",
      color: "#666",
      marginBottom: "20px",
    },
    actionButtons: {
      display: "flex",
      gap: "5px",
      marginBottom: "20px",
      alignItems: "center",
    },
    tableContainer: {
      border: "1px solid #dee2e6",
      borderRadius: "8px",
      overflow: "hidden",
      background: "#fff",
    },
    tableHeader: {
      background: "#f8f9fa",
      display: "grid",
      gridTemplateColumns: "0.5fr 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1.5fr 1fr 1fr 1fr",
      gap: "1px",
      border: "none",
    },
    headerCell: {
      padding: "8px 4px",
      fontSize: "11px",
      fontWeight: "600",
      color: "#495057",
      textAlign: "center",
      background: "#f8f9fa",
      textTransform: "uppercase",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    tableRow: {
      display: "grid",
      gridTemplateColumns: "0.5fr 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1.5fr 1fr 1fr 1fr",
      gap: "1px",
      borderTop: "1px solid #dee2e6",
      background: "#fff",
    },
    tableCell: {
      padding: "4px",
      background: "#fff",
      display: "flex",
      alignItems: "center",
      minHeight: "40px",
    },
    input: {
      width: "100%",
      padding: "4px 6px",
      border: "1px solid #dee2e6",
      borderRadius: "3px",
      fontSize: "12px",
      background: "#fff",
      textAlign: "center",
    },
    select: {
      width: "100%",
      padding: "4px 6px",
      border: "1px solid #dee2e6",
      borderRadius: "3px",
      fontSize: "12px",
      background: "#fff",
    },
    addButton: {
      background: "#28a745",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      padding: "4px 8px",
      fontSize: "11px",
      fontWeight: "600",
      cursor: "pointer",
      width: "100%",
    },
    actionButton: {
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: "4px",
      borderRadius: "3px",
      margin: "0 2px",
    },
    editButton: {
      color: "#007bff",
    },
    deleteButton: {
      color: "#dc3545",
    },
    indexCell: {
      justifyContent: "center",
      fontWeight: "600",
      fontSize: "12px",
    },
  };

  return (
    <>
      {/* <PharmacyReturnModel
        show={showUserTypeModal}
        handleClose={() => setShowUserTypeModal(false)}
        onUserTypeSelect={handleUserTypeSelect}
      /> */}

      <div style={styles.container}>
        <div style={styles.header}>
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <div>
              <button onClick={() => navigate(-1)}>
                <ArrowLeft className="back-arrow" size={24} />
              </button>
            </div>
            <div>
              <h1 style={styles.title}>Add Purchase Return</h1>
              <p style={styles.subtitle}>Fill In The Details Below To Add A New Return</p>
            </div>
          </div>

          <div>
            <button
              className="gradient-button"
              onClick={handleSave}
              style={styles.actionButtons}
            >
              <Save size={12} />
              Save
            </button>
          </div>
        </div>

        <div style={styles.tableContainer}>
          <div style={styles.tableHeader}>
            <div style={styles.headerCell}>#</div>
            <div style={styles.headerCell}>PRODUCT</div>
            <div style={styles.headerCell}>BATCH NO</div>
            <div style={styles.headerCell}>PACK</div>
            <div style={styles.headerCell}>EXPIRY</div>
            <div style={styles.headerCell}>MRP</div>
            <div style={styles.headerCell}>STOCK</div>
            <div style={styles.headerCell}>RETURN</div>
            <div style={styles.headerCell}>DISTRIBUTOR</div>
            <div style={styles.headerCell}>INVOICE NO</div>
            <div style={styles.headerCell}>INVOICE DATE</div>
            <div style={styles.headerCell}></div>
          </div>

          {/* Input Row */}
          <div style={styles.tableRow}>
            <div style={styles.tableCell}></div>
            <div style={styles.tableCell}>
              <input
                type="text"
                placeholder="Search or Scan barcode"
                style={styles.input}
                value={newProduct.product}
                onChange={(e) => handleNewProductChange("product", e.target.value)}
                onFocus={() => setShowProductModal(true)} // Open modal on input focus
              />
            </div>

            <div style={styles.tableCell}>
  <input
    type="text"
    placeholder="Batch"
    style={styles.input}
    value={newProduct.batchNo}
    readOnly
    onClick={handleBatchFieldClick}
  />
</div>

            <div style={styles.tableCell}>
              <input
                type="text"
                style={styles.input}
                value={newProduct.pack}
                onChange={(e) => handleNewProductChange("pack", e.target.value)}
              />
            </div>
            <div style={styles.tableCell}>
              <input
  type="month"
  style={styles.input}
  value={newProduct.expiry} // now YYYY-MM ✔
  onChange={(e) => handleNewProductChange("expiry", e.target.value)}
/>
            </div>
            <div style={styles.tableCell}>
              <input
                type="number"
                style={styles.input}
                value={newProduct.mrp}
                onChange={(e) => handleNewProductChange("mrp", e.target.value)}
              />
            </div>
            <div style={styles.tableCell}>
              <input
                type="text"
                placeholder="Stock"
                style={styles.input}
                value={newProduct.stock}
                onChange={(e) => handleNewProductChange("stock", e.target.value)}
              />
            </div>
            <div style={styles.tableCell}>
              <input
                type="text"
                placeholder="Qty"
                style={styles.input}
                value={newProduct.return}
                onChange={(e) => handleNewProductChange("return", e.target.value)}
              />
            </div>
            <div style={styles.tableCell}>
  <input 
    type="text"
    placeholder="Select Distributor"
    style={styles.input}
    value={newProduct.distributor}
    readOnly
    onClick={() => setShowDistributorModal(true)}
  />
</div>
            <div style={styles.tableCell}>
              <input
                type="text"
                placeholder="Invoice No"
                style={styles.input}
                value={newProduct.invoiceNo}
                onChange={(e) => handleNewProductChange("invoiceNo", e.target.value)}
              />
            </div>
            <div style={styles.tableCell}>
              <input
                type="date"
                placeholder="DD / MM / YYYY"
                style={styles.input}
                value={newProduct.invoiceDate}
                onChange={(e) => handleNewProductChange("invoiceDate", e.target.value)}
              />
            </div>
            <div style={styles.tableCell}>
              <button className="gradient-button" onClick={handleAddProduct}>
                ADD
              </button>
            </div>
          </div>

          {/* Product Rows */}
          {products.map((product, index) => (
            <div key={product.id} style={styles.tableRow}>
              <div style={{ ...styles.tableCell, ...styles.indexCell }}>{index + 1}</div>
              <div style={styles.tableCell}>
                {product.isEditing ? (
                  <input
                    type="text"
                    style={styles.input}
                    value={product.product}
                    onChange={(e) => handleProductChange(product.id, "product", e.target.value)}
                  />
                ) : (
                  <span style={{ fontSize: "12px" }}>{product.product}</span>
                )}
              </div>
              <div style={styles.tableCell}>
                {product.isEditing ? (
                  <input
                    type="text"
                    style={styles.input}
                    value={product.batchNo}
                    onChange={(e) => handleProductChange(product.id, "batchNo", e.target.value)}
                  />
                ) : (
                  <span style={{ fontSize: "12px" }}>{product.batchNo}</span>
                )}
              </div>
              <div style={styles.tableCell}>
                {product.isEditing ? (
                  <input
                    type="text"
                    style={styles.input}
                    value={product.pack}
                    onChange={(e) => handleProductChange(product.id, "pack", e.target.value)}
                  />
                ) : (
                  <span style={{ fontSize: "12px" }}>{product.pack}</span>
                )}
              </div>
              <div style={styles.tableCell}>
                {product.isEditing ? (
                  <input
                    type="month"
                    style={styles.input}
                    value={product.expiry}
                    onChange={(e) => handleProductChange(product.id, "expiry", e.target.value)}
                  />
                ) : (
                  <span style={{ fontSize: "12px" }}>{product.expiry}</span>
                )}
              </div>
              <div style={styles.tableCell}>
                {product.isEditing ? (
                  <input
                    type="number"
                    style={styles.input}
                    value={product.mrp}
                    onChange={(e) => handleProductChange(product.id, "mrp", e.target.value)}
                  />
                ) : (
                  <span style={{ fontSize: "12px" }}>{product.mrp}</span>
                )}
              </div>
              <div style={styles.tableCell}>
                {product.isEditing ? (
                  <input
                    type="text"
                    style={styles.input}
                    value={product.stock}
                    onChange={(e) => handleProductChange(product.id, "stock", e.target.value)}
                  />
                ) : (
                  <span style={{ fontSize: "12px" }}>{product.stock || "1"}</span>
                )}
              </div>
              <div style={styles.tableCell}>
                {product.isEditing ? (
                  <input
                    type="text"
                    style={styles.input}
                    value={product.return}
                    onChange={(e) => handleProductChange(product.id, "return", e.target.value)}
                  />
                ) : (
                  <span style={{ fontSize: "12px" }}>{product.return}</span>
                )}
              </div>
              <div style={styles.tableCell}>
                {product.isEditing ? (
  <input
    type="text"
    style={styles.input}
    value={product.distributor}
    readOnly
    placeholder="Select Distributor"
    onClick={() => {
      // Store the product id in state to know which row is editing distributor
      setEditingDistributorProductId(product.id);
      setShowDistributorModal(true);
    }}
  />
) : (
  <span style={{ fontSize: "12px" }}>{product.distributor}</span>
)}

              </div>
              <div style={styles.tableCell}>
                {product.isEditing ? (
                  <input
                    type="text"
                    style={styles.input}
                    value={product.invoiceNo}
                    onChange={(e) => handleProductChange(product.id, "invoiceNo", e.target.value)}
                  />
                ) : (
                  <span style={{ fontSize: "12px" }}>{product.invoiceNo}</span>
                )}
              </div>
              <div style={styles.tableCell}>
                {product.isEditing ? (
                  <input
                    type="date"
                    style={styles.input}
                    value={product.invoiceDate}
                    onChange={(e) => handleProductChange(product.id, "invoiceDate", e.target.value)}
                  />
                ) : (
                  <span style={{ fontSize: "12px" }}>{product.invoiceDate}</span>
                )}
              </div>
              <div style={styles.tableCell}>
                <button
                  style={{ ...styles.actionButton, ...styles.editButton }}
                  onClick={() => handleEditProduct(product.id)}
                  title="Edit"
                >
                  <FaEdit size={12} />
                </button>
                <button
                  style={{ ...styles.actionButton, ...styles.deleteButton }}
                  onClick={() => handleDeleteProduct(product.id)}
                  title="Delete"
                >
                  <FaTrash size={12} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <ProductSelectModal
        open={showProductModal}
        onClose={() => setShowProductModal(false)}
        onSelect={(product) => {
          setNewProduct((prev) => ({
            ...prev,
            productId: product.productID,
            product: product.productName,
            mrp: product.mrp,
            rate: product.saleRate || "",
            hsn: product.hsn || "",
            pack: product.pack || "",
          }));
          setShowProductModal(false);
        }}
        onCreateNew={() => {
          setShowProductModal(false);
          setShowCreateProductModal(true);
        }}
      />
      <DistributorSelectModal
  show={showDistributorModal}
  onHide={() => {
    setShowDistributorModal(false);
    setEditingDistributorProductId(null);
  }}
  onSelect={(dist) => {
    if (editingDistributorProductId) {
      handleProductChange(editingDistributorProductId, "distributor", dist.distributorName);
    } else {
      // fallback or new product distributor update if needed
      setNewProduct((prev) => ({
        ...prev,
        distributor: dist.distributorName,
      }));
    }
    setShowDistributorModal(false);
    setEditingDistributorProductId(null);
  }}
/>

<ReturnBatchModal
  open={showBatchModal}
  onClose={() => setShowBatchModal(false)}
  onSelect={(batch) => {
     let expiryForInput = "";
    if (batch.expiry) {
      const d = new Date(batch.expiry);
      expiryForInput =
        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    }
    setNewProduct((prev) => ({
      ...prev,
      batchNo: batch.batchNo,
      pack: batch.pack,
      expiry: expiryForInput,        
      mrp: batch.mrp,
      stock: batch.stock,
      return: batch.return,
      distributor: batch.distributor,
      invoiceNo: batch.invoiceNo,
      invoiceDate: batch.invoiceDate,
      rate: batch.purchaseRate,
      // Add any other batch fields as desired
    }));
    setShowBatchModal(false);
  }}
  productId={newProduct.productId}
  productName={newProduct.product}
/>


    </>
  );
}

export default PharmacyPurchasereturn;
